<template>
  <footer class="footer has-cards">
    <div class="container container-lg">
      <section class="section section-lg pt-0">
        <div class="container">
          <card
            gradient="default"
            no-body
            shadow-size="lg"
            class="border-0 floating"
          >
            <div class="p-5">
              <div class="row align-items-center">
                <div class="col-lg-8">
                  <h3 class="text-white">Build Your Future in Fintech</h3>

                  <p class="lead text-white mt-3">
                    Don’t just dream about launching your own fintech business -
                    make it real with TopupBox. We’ll handle the technology, you
                    focus on your customers.
                  </p>
                </div>

                <!-- buttons -->
                <div
                  class="mt-3 d-flex flex-column flex-sm-row"
                  style="gap: 10px"
                >
                  <div
                    class="btn-wrapper d-flex flex-column flex-sm-row"
                    style="gap: 10px"
                  >
                    <router-link to="/register" class="btn btn-info">
                      Start My Fintech Now
                    </router-link>
                    <button
                      to=""
                      class="btn btn-info"
                      @click="showSalesModal = true"
                    >
                      Talk to sales
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
      </section>

      <!--talk to sales Modal -->
      <modal
        :show.sync="showSalesModal"
        modal-classes="modal-dialog-centered modal-sm"
      >
        <!-- header slot -->
        <template #header>
          <h5 class="modal-title">Talk to Sales</h5>
        </template>

        <!-- body slot -->
        <div class="">
          <p class="footer-header d-flex align-items-center" style="gap: 8px">
            <img src="img/icons/common/email.svg" alt="" style="width: 25px" />
            <a href="mailto:sales@topupbox.com">Sales@topupbox.com</a>
          </p>
          <p
            class="footer-header d-flex align-items-center gap-4"
            style="gap: 8px"
          >
            <img
              src="img/icons/common/telephone.png"
              alt=""
              style="width: 25px"
            />
            <a href="tel:+2348123456789">+234 808 3972 277</a>
          </p>
        </div>
      </modal>
    </div>

    <div class="container">
      <div class="footerBg">
        <section id="footer">
          <div class="container">
            <div class="row mb-5">
              <div class="col-md-4 col-sm-12 mb-4">
                <router-link slot="brand" class="mr-lg-5" to="/">
                  <img
                    src="img/brand/blue-logo.png"
                    alt="logo"
                    class="img-fluid"
                    width="180px"
                  />
                </router-link>

                <p class="mt-4 pr-md-3 footer-text-link">
                  91 Ogudu Road,
                  <br />
                  Ojota,
                  <br />
                  Lagos, Nigeria.
                </p>

                <div class="mt-1">
                  <a href="https://twitter.com/topupboxHQ" target="blank">
                    <i
                      class="fa fa-twitter footer-text-link"
                      style="font-size: 16px"
                    >
                    </i>
                  </a>

                  <a href="https://www.facebook.com/topupboxHQ" target="blank">
                    <i
                      class="fa fa-facebook mx-4 footer-text-link"
                      style="font-size: 16px"
                    >
                    </i>
                  </a>

                  <a
                    href="https://www.instagram.com/topupboxhq/"
                    target="blank"
                  >
                    <i
                      class="fa fa-instagram footer-text-link"
                      style="font-size: 16px"
                    >
                    </i>
                  </a>
                </div>
              </div>

              <div class="col-md-6 col-xs-12 py-4">
                <div class="row">
                  <div class="col-xs-6 col-6">
                    <!-- Product -->

                    <h6 class="mb-4 footer-header">
                      <span>PRODUCTS</span>
                    </h6>

                    <p class="my-3">
                      <router-link to="/enterprise" class="footer-text-link">
                        Enterprise
                      </router-link>
                    </p>

                    <p class="my-3">
                      <router-link to="/ussd" class="footer-text-link">
                        USSD
                      </router-link>
                    </p>
                    <p class="my-3">
                      <router-link to="/mobile" class="footer-text-link">
                        Bill payment
                      </router-link>
                    </p>
                    <p class="my-3">
                      <router-link to="/unicard" class="footer-text-link">
                        Unicard
                      </router-link>
                    </p>
                    <p class="my-3">
                      <router-link to="/mobile" class="footer-text-link">
                        Mobile
                      </router-link>
                    </p>
                  </div>
                  <!-- resources -->
                  <div class="col-xs-6 col-6">
                    <h6 class="mb-4 footer-header">
                      <span>RESOURCES</span>
                    </h6>
                    <p class="my-3">
                      <a
                        href="https://medium.com/@topupbox"
                        class="footer-text-link"
                      >
                        Learn
                      </a>
                    </p>

                    <p class="my-3">
                      <router-link to="/faqs" class="footer-text-link">
                        FAQs
                      </router-link>
                    </p>
                    <p class="my-3">
                      <router-link
                        to="/terms-and-conditions"
                        class="footer-text-link"
                      >
                        Terms & Conditions
                      </router-link>
                    </p>
                    <p class="my-3">
                      <router-link to="/api" class="footer-text-link"
                        >API</router-link
                      >
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-2 col-xs-12 mb-4 py-4">
                <div class="row">
                  <div class="col-xs-6 col-12">
                    <h6 class="mb-4 footer-header">
                      <span>SUPPORT</span>
                    </h6>

                    <p class="my-3">
                      <router-link to="/contact-us" class="footer-text-link">
                        Contact Us
                      </router-link>
                    </p>

                    <p class="my-3 footer-text-link">support@topupbox.com</p>

                    <p class="my-3 footer-text-link">+234 818 0458 739</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <hr />

      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            &copy; {{ year }}
            <a
              href="https://www.creative-tim.com"
              target="_blank"
              rel="noopener"
              class="text-dark font-weight-bold"
            >
              TopupBox.
            </a>
            All Right Reserved
          </div>
        </div>

        <div class="col-md-6">
          <div class="nav nav-footer justify-content-end"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Modal from "../../components/Modal.vue";
export default {
  name: "business-footer",
  components: { Modal },
  data() {
    return {
      showSalesModal: false,
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style></style>
